import { Injector, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, switchMap, tap } from 'rxjs';
import { FullScreenDialogConfig } from '../../../_config/full-screen-dialog-config';
import { UploadedDocument } from '../../../_core/models/uploaded-document';
import { BucketService } from '../../../_core/services/bucket.service';
import { PdfDialogComponent } from '../../../_widgets/pdf-dialog/pdf-dialog.component';
import { DownloadDocumentCommand } from './download-document-command';
import { ICommand } from './i-command';

export class SeeDocumentCommand extends DownloadDocumentCommand {
  override icon = 'eye';
  override label = 'Visualizza documento';
  override tooltip = 'Visualizza documento';

  constructor(
    inj: Injector,
    private viewType: 'pdf-viewer' | 'new-window' = 'new-window',
    service: Type<{
      getFile: (path: string) => Observable<any>;
    }> = BucketService
  ) {
    super(inj, service);
  }
  override execute(element: UploadedDocument, ...args: unknown[]) {
    return this.getDoc(element);
  }

  private getDoc(doc: UploadedDocument) {
    let request$: Observable<any> | undefined;
    if (doc.mimeType === 'application/pdf' && this.viewType === 'pdf-viewer') {
      request$ = this.openPdfViewer(doc);
    } else {
      request$ = this.openFileTab(doc);
    }
    return request$;
  }

  private openPdfViewer(doc: UploadedDocument) {
    return this.service.getFile(doc.path).pipe(
      switchMap((blob) => blob.arrayBuffer()),
      tap((res) => {
        this.dialog.open(PdfDialogComponent, {
          ...FullScreenDialogConfig,
          data: { pdfSrc: res, title: doc.nome },
        });
      })
    );
  }

  private openFileTab(doc: UploadedDocument) {
    return this.getFile(doc).pipe(
      tap((url) => {
        window.open(url, 'blank');
      })
    );
  }
}
